import { getStorageData, saveStorageData } from '@/storage'

interface States {
  fontSize?: number
  contrast?: string | false
  [key: string]: unknown
}

interface UserSettings {
  lang?: string
  states?: States
  updatedAt?: Date
  position?: string
}

export const userSettings: UserSettings = {
  lang: 'id',
  position: undefined,
  states: {},
}

export const STORAGE_KEY = 'asw-user-settings'

export function setUserStateSettings(state: Partial<States>) {
  userSettings.states = {
    ...userSettings.states,
    ...state,
  }

  saveUserSettings()
}

export function saveUserSettings() {
  saveStorageData(STORAGE_KEY, userSettings)
}

export function getSavedUserSettings(): UserSettings {
  return (getStorageData(STORAGE_KEY) as UserSettings) ?? { states: {} }
}

const activeStateKeys = ['readable-font', 'readable-guide', 'big-cursor', 'screen-reader', 'contrast']

export function getActiveStatesCount() {
  let count = 0
  const states = userSettings.states
  for (let i = 0; i < activeStateKeys.length; i++) {
    if (states && states[activeStateKeys[i]]) count++
  }

  if (states && states.fontSize !== undefined && states.fontSize !== 1) count++
  return count
}
